import { useExperiment } from '@statsig/react-bindings';

import type { ActiveExperiments } from '../consts/activeExperiments';

const useStatsigExperiment = (experimentName: ActiveExperiments) => {
  const config = useExperiment(experimentName);
  const { value } = config;
  //if the user fails to pass a feature gate in the experiment, the group with return null/undefined and we will default to control
  const group = config.groupName ?? 'Control';

  return { experience: group, value };
};
export default useStatsigExperiment;
